import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=60b5fc1e"
import script from "./Completed.vue?vue&type=script&lang=js"
export * from "./Completed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports